import axiosInstance from '../axiosInterceptor/axiosInstance'

// Backend (BUS-2798 Social slice): POST /api/v1/orgs/{orgId}/social/accounts/long-lived-token.
// The short-lived token travels in the POST body, never in the URL/query, so it can't leak into
// access logs/proxies/history (BUS-2837). orgId is passed in by the caller (single source of
// truth, shared with the status/connect/unlink calls). Backend responds with { accessToken };
// we return the raw token string so callers can feed it straight to the Graph API (getAccounts)
// without unwrapping.
const getLongLivedToken = async ({ orgId, accessToken }) => {
  const response = await axiosInstance.post(
    `v1/orgs/${orgId}/social/accounts/long-lived-token`,
    { accessToken },
  )
  return response?.data?.accessToken
}

export default getLongLivedToken
